import states from "us-state-codes";

import {RegionStateMap} from "../constants/regionStateMap";
import {RegionSlug} from "../store/types";
import {fetchCities} from "./fetchCities";

export const getStateCodeByName = (name = ""): string =>
  states.getStateCodeByStateName(name.replace(/-/g, " ")) || "";

export const getCityAndStatesOptions = async (): Promise<string[]> => {
  const cityAndStates = await fetchCities();

  return cityAndStates
    .sortBy(["state", "city"])
    .map(c => {
      const stCode = states.getStateCodeByStateName(c.state);
      const ci = c.city;
      return [c.state, `${ci}, ${stCode}`];
    })
    .flat()
    .distinct();
};

/**
 *
 * @param cityAndState i.e. "San Francisco, CA" or "California"
 * @returns [city, state]
 */
export const getCityAndState = (
  cityAndState: string,
): [city: string | null, state: string | null] => {
  if (!cityAndState) {
    return [null, null];
  }
  const keyVals = cityAndState.split(",");
  const hasCity = keyVals.length > 1;
  const state = hasCity ? states.getStateNameByStateCode(keyVals[1]) : keyVals[0];
  const city = hasCity ? keyVals[0] : null;
  return [city, state];
};

export const getStateCodeFromRegionSlug = (string: RegionSlug | unknown): string | null =>
  // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Record<"new-york" | "los-angeles" | "greater-san-diego" | "seattle" | "florida" | "sf-bay-area" | "ohio" | "new-jersey" | "colorado" | "texas" | "arizona" | "missouri" | "virginia" | ... 10 more ... | "north-carolina", { ...; }>'.
  typeof string === "string" && string in RegionStateMap ? RegionStateMap[string].code : null;
